import { createContext, useContext } from 'react';

/**
 * Auth context — UI shape { user, isAuthenticated, isLoading, logout, updateUser }.
 * State is sourced from the Redux auth slice (session restore + login thunks).
 */
const AuthContext = createContext(null);

export const useAuthContext = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuthContext must be used within an AuthProvider');
    }
    return context;
};

export default AuthContext;
